import { useRef, useState } from "react";
import { useSendEmail } from "../../../../utils/customHooks";

import {
	Section,
	TextRow,
	SectionHeading,
	FormContainer,
	CollaborateContainer,
	ExpectationList,
	ContactContainer,
	Form,
	Input,
	TextArea,
	FormButton,
	NotificationBar,
	NotificationContainer,
} from "./styles";

import FileInput from "../../../Molecules/Careers/FileInput";

import successIcon from "../../../../Assets/Images/NotificationBar/success.webp";
import warningIcon from "../../../../Assets/Images/NotificationBar/warning.webp";

const ShareVision = ({ id }) => {
	const [formData, setFormData] = useState({
		fullName: "",
		email: "",
		position: "",
		cv: null,
	});
	const { sendEmail, validationErrors, setValidationErrors, formRefs } =
		useSendEmail("https://server.spesna.com/api/careers/submit");
	const [notification, setNotification] = useState({
		message: "",
		type: "",
		visible: false,
	});
	const formRef = useRef(null);

	const handleChange = (e) => {
		const { name, value, files } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: files ? files[0] : value,
		}));
		// Clear the error for the specific field being modified
		setValidationErrors((prevErrors) => ({
			...prevErrors,
			[name]: "",
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		e.stopPropagation();

		const response = await sendEmail(formData);
		if (response === "SUCCESS") {
			setNotification({
				message: "Email sent successfully!",
				type: "success",
				visible: true,
			});
			setFormData({
				fullName: "",
				email: "",
				position: "",
				cv: null,
			});
		} else {
			setNotification({
				message: "Error sending email.",
				type: "warning",
				visible: true,
			});
		}

		setTimeout(() => {
			setNotification((prev) => ({ ...prev, visible: false }));
		}, 2000);
	};

	return (
		<Section id={id}>
			{notification.visible && (
				<NotificationBar>
					{notification.type === "success" ? (
						<NotificationContainer success={1}>
							<img src={successIcon} alt="icon" />
							<span>{notification.message}</span>
						</NotificationContainer>
					) : (
						<NotificationContainer success={0}>
							<img src={warningIcon} alt="icon" />
							<span>{notification.message}</span>
						</NotificationContainer>
					)}
				</NotificationBar>
			)}
			<SectionHeading>
				<div>
					<TextRow>Can't find the job</TextRow>
				</div>
				<div>
					<TextRow>you need?</TextRow>
				</div>
			</SectionHeading>
			<FormContainer>
				<CollaborateContainer>
					<h2>That's not a problem</h2>
					<p>
						We’re always on the lookout for passionate, skilled
						individuals even if we don’t have the perfect role
						listed right now.
					</p>
					<p>
						Join our talent pool and stay connected with our team.
						Whether you're a designer, developer, strategist, or
						creative thinker, we’d love to hear from you.
					</p>
					<h3>Here’s what you can expect:</h3>
					<ExpectationList>
						<span>→ We'll get back to you within 24 hours</span>
						<span>
							→ Your will be talking with our tech project
							managers
						</span>
					</ExpectationList>
					<h4>Or</h4>
					<hr />
					<ContactContainer>
						<span>Call us +374 77 73 33 73</span>
						<span>Say hi contact@spesna.com</span>
					</ContactContainer>
				</CollaborateContainer>
				<Form ref={formRef} onSubmit={handleSubmit}>
					<div>
						<Input
							ref={formRefs.fullName}
							type={"text"}
							placeholder={"Name*"}
							name="fullName"
							onChange={handleChange}
							error={validationErrors.fullName ? 1 : 0}
						/>
						{validationErrors.fullName && (
							<p>{validationErrors.fullName}</p>
						)}
					</div>
					<div>
						<Input
							ref={formRefs.email}
							type={"text"}
							placeholder={"Email*"}
							name="email"
							onChange={handleChange}
							error={validationErrors.email ? 1 : 0}
						/>
						{validationErrors.email && (
							<p>{validationErrors.email}</p>
						)}
					</div>
					<div>
						<Input
							// Temp: change ref
							ref={formRefs.company}
							type={"text"}
							placeholder={"Position"}
							name="position"
							onChange={handleChange}
						/>
					</div>
					<div>
						<FileInput
							// ref={formRefs.siteURL}
							type={"file"}
							placeholder={"Attach your CV"}
							name="cv"
							onChange={handleChange}
							accept="image/jpeg, image/png, application/pdf"
							// error={validationErrors.siteURL ? 1 : 0}
						/>
						{validationErrors.siteURL && (
							<p>{validationErrors.siteURL}</p>
						)}
					</div>
					<div>
						<FormButton type="submit">Send</FormButton>
					</div>
				</Form>
			</FormContainer>
		</Section>
	);
};

export default ShareVision;
